// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__16f9_","question":"styles_question__3h9gu","description":"styles_description__RX6t7"};